// The approve confirmation sends the same body as an untouched onboarding
// Send: server defaults, the current fingerprint, and no peer invalidation.
import { blockedReasonMessage } from "../blockedReason";
import { inputConfig } from "../config";
import type { DraftEvaluation, SendRequest } from "../types";
import { sendSettings } from "./sendSettings";

export type DefaultOnboardingPlan = {
  /** Null when this approval should not create another flow. */
  request: SendRequest | null;
  notice: string;
  /** The notice is a failure: the contract cannot be sent. */
  error: boolean;
};

function openOnboarding(evaluation: DraftEvaluation): boolean {
  return evaluation.open_flows.some((flow) => flow.flow_type === "onboarding");
}

/** What confirming Approve will do with the default onboarding flow. */
export function planDefaultOnboarding(evaluation: DraftEvaluation): DefaultOnboardingPlan {
  if (openOnboarding(evaluation)) {
    return {
      request: null,
      error: false,
      notice: "An onboarding flow is already open. This approval will not send another.",
    };
  }
  if (!evaluation.sendable) {
    const reason = evaluation.blocked_reason?.trim();
    return {
      request: null,
      error: true,
      notice: reason
        ? `Cannot send the contract. ${blockedReasonMessage(reason)}`
        : "Cannot send the contract.",
    };
  }
  const config = inputConfig(evaluation);
  return {
    request: {
      flow_type: "onboarding",
      config,
      sent_as: evaluation.defaults.sent_as,
      message: "",
      ...sendSettings(config, evaluation.defaults),
      invalidate_flow_ids: [],
      supersede_submission_ids: [],
      accepted_fingerprint: evaluation.assessment.fingerprint,
    },
    error: false,
    notice: "",
  };
}
